// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('CountryCodeVO')
export class CountryCodeVO {

  public static INTERNATIONAL_CODE_TYPE: number  = 1;

  @JsonProperty('countryCode', 'string')
  public countryCode: string = undefined;

  @JsonProperty('displayName', 'string')
  public displayName: string = undefined;

  @JsonProperty('sortOrder', 'Number')
  public sortOrder: number = undefined;

  @JsonProperty('codeType', 'Number')
  public codeType: number = undefined;

}
